import { Constants } from '@adobe/aem-spa-page-model-manager';

import { ExperienceFragment } from '@/components/ExperienceFragment/ExperienceFragment';
import { TermFinder as FeatureTermFinder } from '@/features/TermFinder';

const TermFinder = (props) => {
    const { accordionItems, noResultsFragment, searchServerErrorFragment } = props;

    const normalizesAccordionItems = accordionItems.map((i, index) => {
        const links = i.links.map((l, index) => ({
            ...l,
            id: `${index}`,
        }));

        links.sort((a, b) => {
            const na = a.label;
            const nb = b.label;

            if (na < nb) {
                return -1;
            } else if (na > nb) {
                return 1;
            }

            return 0;
        });

        return {
            ...i,
            id: `${index}`,
            title: i.label,
            links,
        };
    });

    normalizesAccordionItems.sort((a, b) => {
        const na = a.title;
        const nb = b.title;

        if (na < nb) {
            return -1;
        } else if (na > nb) {
            return 1;
        }

        return 0;
    });

    const noResults = noResultsFragment ? (
        <ExperienceFragment
            cqItems={noResultsFragment[Constants.ITEMS_PROP]}
            cqItemsOrder={noResultsFragment[Constants.ITEMS_ORDER_PROP]}
            {...noResultsFragment}
        />
    ) : undefined;
    const error = searchServerErrorFragment ? (
        <ExperienceFragment
            cqItems={searchServerErrorFragment[Constants.ITEMS_PROP]}
            cqItemsOrder={searchServerErrorFragment[Constants.ITEMS_ORDER_PROP]}
            {...searchServerErrorFragment}
        />
    ) : undefined;

    return (
        <FeatureTermFinder
            {...props}
            noResultsComponent={noResults}
            errorComponent={error}
            accordionItems={normalizesAccordionItems}
        />
    );
};

export default TermFinder;
